// src/pages/About.jsx
import React from 'react';
import Layout from '../components/Layout.jsx';
// import MainMenu from '../components/MainMenu.jsx';
import { client } from '../lib/client.js';
import { aboutQuery } from '../lib/queries.js';
import { PortableText } from '@portabletext/react';
import { Helmet } from 'react-helmet';

export default function About() {
  const [data, setData] = React.useState(null);
  const [err, setErr] = React.useState(null);

  React.useEffect(() => {
    window.scrollTo(0, 0);
    client.fetch(aboutQuery).then(setData).catch(setErr);
  }, []);

  if (err) return null;   // suppress error copy
  if (!data) return null; // suppress loading copy

  const siteUrl = 'https://this-belongs-to.com';
  const canonicalUrl = `${siteUrl}/pages/about-us`;

  const metaTitle = data.seoTitle || data.headline || 'About | This Belongs To';
  let metaDescription =
    data.metaDescription ||
    'This Belongs To is an underwear and clothing brand working with layered jerseys, soft silhouettes and considered colour palettes.';
  metaDescription = metaDescription.replace(/\s+/g, ' ').trim();
  if (metaDescription.length > 160) {
    metaDescription = `${metaDescription.slice(0, 157)}...`;
  }

  const ogImage = data.imageUrl || null;

  return (
    <Layout>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={canonicalUrl} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:url" content={canonicalUrl} />
        {ogImage && <meta property="og:image" content={ogImage} />}

      </Helmet>

      {/* <MainMenu /> */}

      <div className="container mx-auto py-0 px-4 w-full md:w-1/2 lg:w-4/5">
        {data.headline && (
          <h1 className="text-3xl italic mb-4 mt-8 text-center">
            {data.headline}
          </h1>
        )}

        <div className="mb-4 text-center">
          <PortableText
            value={data.body}
            components={{
              block: {
                normal: ({ children }) => <p className="mb-4">{children}</p>,
              },
              marks: {
                strong: ({ children }) => <strong>{children}</strong>,
                em: ({ children }) => <em>{children}</em>,
                link: ({ value, children }) => (
                  <a
                    href={value?.href}
                    target="_blank"
                    rel="noreferrer"
                    className="underline"
                  >
                    {children}
                  </a>
                ),
              },
            }}
          />
        </div>

        {data.imageUrl && (
          <figure className="flex flex-col items-center justify-center mb-8 mt-10">
            <img
              src={data.imageUrl}
              alt={data.imageAlt || ''}
              className="h-72"
              loading="lazy"
            />
            {data.imageCaption && (
              <figcaption className="mt-2 text-sm text-center opacity-80">
                {data.imageCaption}
              </figcaption>
            )}
          </figure>
        )}
      </div>
    </Layout>
  );
}
